import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import { BsCheckCircle, BsCheckCircleFill } from "react-icons/bs";
import { stateListData, cityList } from "@/api/bid";
import { validateForm } from "@/utils/formValidator";

const EditClosingAgentAndTitleInsuranceProvider = ({
  setCollapseAccordian,
  collapseAccordian,
  cifData,
  submittedAccordions,
  setSubmittedAccordions,
  isEnabled,
  titleInsuranceForm,
  setTitleInsuranceForm,
  closingAgentForm,
  setClosingAgentForm,
  selectedClosingOption,
  setSelectedClosingOption,
}) => {
  const closingData = cifData?.data?.closingOptionDetails?.[0] || {};
  const closingDataDetails = cifData?.data?.closingDetail?.closingAgent;
  const titleInsuranceProvider =
    cifData?.data?.closingDetail?.titleInsuranceProvider;
  const [validated, setValidated] = useState(false);
  const [titleInsuranceValidated, setTitleInsuranceValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [citiesClosingAgent, setCitiesClosingAgent] = useState([]);
  const [citiesTitleInsurance, setCitiesTitleInsurance] = useState([]);

  const [citySuggestions, setCitySuggestions] = useState([]);
  const [citySuggestionsClosingAgent, setCitySuggestionsClosingAgent] =
    useState([]);

  const [allCities, setAllCities] = useState([]);
  const [showSuggestionsClosingAgent, setShowSuggestionsClosingAgent] =
    useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // const staticClosingData = [
  //   {
  //     closingOptionType: "SELLER_PAYS",
  //     titleInsuranceFeeDetail: {
  //       stateName: "IA",
  //       insuranceAmount: 1641,
  //       formattedInsuranceAmount: "$1,641",
  //     },
  //     isClosingAgentRequired: true,
  //     isTitleInsuranceProviderRequired: true,
  //   },
  // ];

  // Use static data instead of API response
  // const closingData = staticClosingData[0] || {};
  const {
    isClosingAgentRequired,
    isTitleInsuranceProviderRequired,
    closingOptionType,
    titleInsuranceFeeDetail,
  } = closingData;
  // State for form fields if needed

  const [validationErrors, setValidationErrors] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
  });

  const [closingAgentValidationErrors, setClosingAgentValidationErrors] =
    useState({
      name: "",
      email: "",
      company: "",
      phone: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
    });

  const [stateList, setStatelist] = useState([]);

  // const handleSubmit = () => {
  //   setSubmittedAccordions((prev) => [...prev, 4]); // Mark this accordion as submitted

  //   setCollapseAccordian(5);
  // };

  const titleFormRef = useRef(null);
  const closingFormRef = useRef(null);
  useEffect(() => {
    if (collapseAccordian === 4) {
     
    }
  }, [collapseAccordian]);

  useEffect(() => {
    setClosingAgentForm({
      name: closingDataDetails?.name,
      email: closingDataDetails?.email,
      company: closingDataDetails?.companyName,
      phone: closingDataDetails?.phone,
      address1: closingDataDetails?.address1,
      address2: closingDataDetails?.address2,
      city: closingDataDetails?.city,
      state: closingDataDetails?.stateId,
      zip: closingDataDetails?.zip,
    });
    setTitleInsuranceForm({
      name: titleInsuranceProvider?.name,
      email: titleInsuranceProvider?.email,
      company: titleInsuranceProvider?.companyName,
      phone: titleInsuranceProvider?.phone,
      address1: titleInsuranceProvider?.address1,
      address2: titleInsuranceProvider?.address2,
      city: titleInsuranceProvider?.city,
      state: titleInsuranceProvider?.stateId,
      zip: titleInsuranceProvider?.zip,
    });
  }, [cifData]);

  const fetchCities = async (stateId) => {
    try {
      const response = await cityList(stateId);
      setAllCities(response?.data?.data || []);
      setCitySuggestions([]);
      setCitySuggestionsClosingAgent([]);
      setShowSuggestions(false);
      setShowSuggestionsClosingAgent(false);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setAllCities([]);
    }
  };

  useEffect(() => {
    if (titleInsuranceForm.state) {
      fetchCities(titleInsuranceForm.state);
    }
  }, [titleInsuranceForm.state]);

  // Fetch cities when state changes for co-buyer
  useEffect(() => {
    if (closingAgentForm.state) {
      fetchCities(closingAgentForm.state);
    }
  }, [closingAgentForm.state]);

  const scrollToFirstInvalidField = (formRef) => {
    const invalidField = formRef.current?.querySelector(":invalid");
    if (invalidField) {
      invalidField.scrollIntoView({ behavior: "smooth", block: "center" });
      invalidField.focus();
    }
  };

  const handleTitleInsuranceSubmit = () => {
    const form = titleFormRef.current;
    if (!form) return false;

    const isValid = form.checkValidity();
    if (!isValid) {
      setTitleInsuranceValidated(true); // show validation UI
      scrollToFirstInvalidField(titleFormRef);
    }
    return isValid;
  };

  const handleClosingAgentSubmit = () => {
    const form = closingFormRef.current;
    if (!form) return false;

    const isValid = form.checkValidity();
    if (!isValid) {
      setValidated(true); // show validation UI
      scrollToFirstInvalidField(closingFormRef);
    }
    return isValid;
  };

  const handleSubmit = (event) => {
    if (
      isClosingAgentRequired &&
      isTitleInsuranceProviderRequired &&
      selectedClosingOption === "BUYER_PAYS"
    ) {
      event.preventDefault();

      for (const [key, value] of Object.entries(titleInsuranceForm)) {
       
        const validationError = validationRules[key](value);
        setValidationErrors((prev) => ({
          ...prev,
          [key]: validationError,
        }));
      }

      for (const [key, value] of Object.entries(closingAgentForm)) {
        const validationError = validationRules[key](value);
        setClosingAgentValidationErrors((prev) => ({
          ...prev,
          [key]: validationError,
        }));
      }

      const titleValid = handleTitleInsuranceSubmit();
      const closingValid = handleClosingAgentSubmit();


      if (titleValid && closingValid && titleInsuranceFeeDetail) {
        setSubmittedAccordions((prev) => [...prev, 4]);
        setCollapseAccordian(5);
        window.scrollTo(0, 900); //Need Fix
      }
    } else {
      setSubmittedAccordions((prev) => [...prev, 4]);
      setCollapseAccordian(5);
    }
  };

  const validationRules = {
    name: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    email: (value) => {
      if (!value) return "This field is required";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return "Please enter a valid email address";
      }
      return "";
    },
    company: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    phone: (value) => {
      if (!value) return "This field is required";
      if (!/^\d{10}$/.test(value)) return "Please enter a valid phone number";
      return "";
    },
    address1: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9#(),.'\s]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _ #";
      }
      return "";
    },
    address2: (value) => {
      // if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9#(),.'\s]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _#";
      }
      return "";
    },
    city: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    state: (value) => {
      if (!value) return "This field is required";
      return "";
    },
    zip: (value) => {
      if (!value) return "This field is required";
      if (!/^\d{5}$/.test(value))
        return "Please enter a valid 5-digit ZIP code";
      return "";
    },
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    if (validationRules[id]) {
      const validationError = validationRules[id](value);
      setValidationErrors((prev) => ({
        ...prev,
        [id]: validationError,
      }));
    }
  };
  const handleBlurClosingAgent = (e) => {
    const { id, value } = e.target;


    if (validationRules[id]) {
      const validationError = validationRules[id](value);

      setClosingAgentValidationErrors((prev) => ({
        ...prev,
        [id]: validationError,
      }));
    }
  };

  useEffect(() => {
    stateListData().then((res) => {
      setStatelist(res.data);
    });
  }, []);

  const handleChangeClosingAgent = (e) => {
    const { id, value } = e.target;
    // Check if this is the phone field


    let processedValue = value;
    if (id === "phone" || id === "phoneNumber" || id === "zip") {
      // Remove all alphabet characters
      processedValue = value.replace(/[a-zA-Z]/g, "");
    }

    if (id === "city" && value.length > 2) {
      const filteredCities = allCities.filter((city) =>
        city.toLowerCase().includes(value.toLowerCase())
      );

      setCitySuggestionsClosingAgent(filteredCities);
      setShowSuggestionsClosingAgent(true);
    } else if (id === "city") {
      setCitySuggestionsClosingAgent([]);
      setShowSuggestionsClosingAgent(false);
    }

    setClosingAgentForm((prevData) => ({
      ...prevData,
      [id]: processedValue,
    }));
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    // Check if this is the phone field
    let processedValue = value;
    if (id === "phone" || id === "phoneNumber" || id === "zip") {
      // Remove all alphabet characters
      processedValue = value.replace(/[a-zA-Z]/g, "");
    }
    if (id === "city" && value.length > 2) {
      const filteredCities = allCities.filter((city) =>
        city.toLowerCase().includes(value.toLowerCase())
      );

      setCitySuggestions(filteredCities);
      setShowSuggestions(true);
    } else if (id === "city") {
      setCitySuggestions([]);
      setShowSuggestions(false);
    }

    setTitleInsuranceForm((prevData) => ({
      ...prevData,
      [id]: processedValue,
    }));
  };

  const handleSuggestionClickClosingAgent = (suggestion) => {
    setClosingAgentForm((prev) => ({
      ...prev,
      city: suggestion,
    }));

    setCitySuggestionsClosingAgent([]);
    setShowSuggestionsClosingAgent(false);
  };

  const handleSuggestionClick = (suggestion) => {
    setTitleInsuranceForm((prev) => ({
      ...prev,
      city: suggestion,
    }));

    setCitySuggestions([]);
    setShowSuggestions(false);
  };
  return (
    <>
      <div className="accordion-item closing-title-accordion">
        <h2 className="accordion-header">
          <button
            className={`accordion-button ${
              collapseAccordian === 4 ? "" : "collapsed"
            }`}
            type="button"
            onClick={(e) => e.preventDefault()}
            aria-expanded={collapseAccordian === 4}
          >
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex align-items-center">
                {submittedAccordions?.includes(4) && collapseAccordian !== 4 ? (
                  <BsCheckCircleFill className="icon_bid me-2" size={30} />
                ) : (
                  <BsCheckCircleFill className="text-dark me-2" size={30} />
                )}
                <span className="bid_font_cif">
                  {" "}
                  Closing Agent and Title Company Information
                </span>
              </div>

              {submittedAccordions?.includes(4) && collapseAccordian !== 4 && (
                <Button
                  variant=""
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setCollapseAccordian(4);
                  }}
                  className="editCifLink"
                >
                  Edit
                </Button>
              )}
            </div>
          </button>
        </h2>

        {/* Add Summary Section */}
        {collapseAccordian !== 4 && submittedAccordions?.includes(4) && (
          <div className="summary-section p-2 border-bottom">
            <div className="ms-4">
              <p className="m-2">
                <strong className="cifTxt">
                  Title insurance and property search fees will be covered by:{" "}
                </strong>
                {selectedClosingOption === "SELLER_PAYS" ? "Seller" : "Buyer"}
              </p>
              {selectedClosingOption === "BUYER_PAYS" && (
                <Row className="pt30 pl30">
                  <Col xs={12} md={4}>
                    {isClosingAgentRequired && closingAgentForm.name && (
                      <p className="mb-3">
                        <strong>Closing Agent: </strong>
                        <p className="pt20">Name:{closingAgentForm.name} </p>
                        <p>Email:{closingAgentForm.email} </p>
                      </p>
                    )}
                  </Col>
                  <Col xs={12} md={4}>
                    {isTitleInsuranceProviderRequired && titleInsuranceForm && (
                      <p className="mb-3">
                        <strong>Title Provider: </strong>

                        <p className="pt20">Name:{titleInsuranceForm?.name} </p>
                        <p>Email:{titleInsuranceForm?.email} </p>

                        {/* Add your title insurance provider details here */}
                      </p>
                    )}
                  </Col>
                </Row>
              )}
            </div>
          </div>
        )}
        <div
          className={`accordion-collapse collapse ${
            collapseAccordian === 4 ? "show" : ""
          }`}
          data-bs-parent="#accordionFlushExample"
        >
          {/* Original accordion body stays exactly the same */}
          {isEnabled && (
            <div className="accordion-body">
              {/* If both are not required, show the default message */}
              {/* {!isClosingAgentRequired && !isTitleInsuranceProviderRequired && (
              <div>
                <p className="d-flex">
                  Title insurance and property search fees will be covered by:
                  <br />
                  {closingOptionType === "SELLER_PAYS" ? (
                    <>
                      Seller Pays: Buyer uses Premium Title Services, the
                      seller's preferred title partner and closing agent. This
                      lets the buyer bypass the title insurance fees, related
                      search costs and reduced escrow/closing fees, since the
                      seller will cover the charges. The standard charge for
                      title insurance services in{" "}
                      {titleInsuranceFeeDetail?.stateName} is{" "}
                      {titleInsuranceFeeDetail?.formattedInsuranceAmount}.
                      Please note that buyers making all-cash purchases are
                      automatically opted in to save through this method.
                    </>
                  ) : (
                    "Buyer Pays" // Add appropriate message for buyer pays scenario
                  )}
                </p>
              </div>
            )} */}
              {!isClosingAgentRequired &&
              !isTitleInsuranceProviderRequired &&
              cifData?.data?.closingOptionDetails?.length === 1 ? (
                <div>
                  <p className="cifTxt">
                    Title insurance and property search fees will be covered by:
                  </p>
                  <br /> <br />
                  <p className="cifTxt">
                    {selectedClosingOption === "SELLER_PAYS" ? (
                      <>
                        <strong className="cifTxt">Seller Pays:</strong> Buyer
                        uses Premium Title Services, the seller's preferred
                        title partner and closing agent. This lets the buyer
                        bypass the title insurance fees, related search costs
                        and reduced escrow/closing fees, since the seller will
                        cover the charges.{" "}
                        <strong>
                          The standard charge for title insurance services in{" "}
                          {titleInsuranceFeeDetail?.stateName} is{" "}
                          {titleInsuranceFeeDetail?.formattedInsuranceAmount}
                        </strong>
                        . Please note that buyers making all-cash purchases are
                        automatically opted in to save through this method.
                        <br />
                        <br />
                      </>
                    ) : (
                      <strong>Buyer Pays</strong>
                    )}
                  </p>
                </div>
              ) : (
                <div>
                  <p className="cifTxt">
                    Title insurance and property search fees will be covered by:
                    {cifData?.data?.closingOptionDetails === null ? " NA" : ""}
                  </p>
                  <br /> <br />
                </div>
              )}

              {cifData?.data?.closingOptionDetails?.length > 1 && (
                <Col md={12} className="mb-4 pb30">
                  {cifData?.data?.closingOptionDetails.map(
                    (option) => (
                      (
                        <Form.Check
                          key={option?.closingOptionType}
                          type="radio"
                          className="pt20 "
                          id={`mortgage-closing-option-${option?.closingOptionType}`}
                          name="mortgageClosingOption"
                          label={
                            <div className="ms-2">
                              <strong>
                                {option?.closingOptionType === "BUYER_PAYS"
                                  ? "Buyer Pays:"
                                  : "Seller Preferred:"}
                              </strong>
                              <span>
                                {option?.closingOptionType === "BUYER_PAYS" ? (
                                  " Buyer uses their own title partner and closing agent without any consideration from the seller. The buyer will then be able to select a title provider and closing agent but will also be responsible for all title insurance fees and related search expenses."
                                ) : (
                                  <>
                                    {" "}
                                    Buyer uses Premium Title Services, the
                                    seller's preferred title partner and closing
                                    agent. This lets the buyer bypass the title
                                    insurance fees, related search costs and
                                    reduced escrow/closing fees, since the
                                    seller will cover the charges.
                                    {titleInsuranceFeeDetail && (
                                      <strong>
                                        {" "}
                                        The standard charge for title insurance
                                        services in{" "}
                                        {
                                          titleInsuranceFeeDetail.stateName
                                        } is{" "}
                                        {
                                          titleInsuranceFeeDetail.formattedInsuranceAmount
                                        }
                                        .
                                      </strong>
                                    )}
                                  </>
                                )}
                              </span>
                            </div>
                          }
                          value={option?.closingOptionType}
                          checked={
                            selectedClosingOption === option?.closingOptionType
                          }
                          onChange={(e) =>
                            setSelectedClosingOption(e.target.value)
                          }
                        />
                      )
                    )
                  )}
                </Col>
              )}

              <Row>
                <Col xs={12} md={6}>
                  {/* Closing Agent Form */}
                  {isClosingAgentRequired &&
                    selectedClosingOption === "BUYER_PAYS" && (
                      <>
                        <strong className="cifTxt mb100 mt100">
                          Title insurance and property search fees will be
                          covered by:{" "}
                        </strong>
                        <div className="mb-4">
                          <h4 className="pt20">Closing Agent </h4>
                          <div className="row pt30">
                            <form
                              ref={closingFormRef}
                              noValidate
                              validated={validated}
                              onSubmit={handleSubmit}
                            >
                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="name"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>First Name</Form.Label>
                                  <span
                                    className=""
                                    style={{ color: "#d13b3b" }}
                                  >
                                    *
                                  </span>
                                  <Form.Control
                                    required
                                    type="text"
                                    placeholder="First Name"
                                    value={closingAgentForm.name}
                                    onChange={handleChangeClosingAgent}
                                    onBlur={handleBlurClosingAgent}
                                    maxLength={50}
                                    isInvalid={
                                      !!closingAgentValidationErrors.name
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {closingAgentValidationErrors.name ||
                                      "This field is required"}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="email"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>Email</Form.Label>
                                  <span
                                    className=""
                                    style={{ color: "#d13b3b" }}
                                  >
                                    *
                                  </span>

                                  <Form.Control
                                    required
                                    type="email"
                                    placeholder="Email"
                                    value={closingAgentForm.email}
                                    onChange={handleChangeClosingAgent}
                                    onBlur={handleBlurClosingAgent}
                                    isInvalid={
                                      !!closingAgentValidationErrors.email
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter a valid email address.
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="company"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>Company</Form.Label>
                                  <span
                                    className=""
                                    style={{ color: "#d13b3b" }}
                                  >
                                    *
                                  </span>

                                  <Form.Control
                                    required
                                    type="text"
                                    placeholder="Company"
                                    value={closingAgentForm.company}
                                    onChange={handleChangeClosingAgent}
                                    onBlur={handleBlurClosingAgent}
                                    maxLength={50}
                                    isInvalid={
                                      !!closingAgentValidationErrors.company
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {closingAgentValidationErrors.company ||
                                      "This field is required"}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="phone"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>Phone</Form.Label>
                                  <span
                                    className=""
                                    style={{ color: "#d13b3b" }}
                                  >
                                    *
                                  </span>
                                  <Form.Control
                                    required
                                    type="tel"
                                    placeholder="Phone"
                                    value={closingAgentForm.phone}
                                    maxLength={10}
                                    onChange={handleChangeClosingAgent}
                                    onBlur={handleBlurClosingAgent}
                                    isInvalid={
                                      !!closingAgentValidationErrors.phone
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {closingAgentValidationErrors.phone ||
                                      "This field is required"}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="address1"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>Address1</Form.Label>
                                  <span
                                    className=""
                                    style={{ color: "#d13b3b" }}
                                  >
                                    *
                                  </span>

                                  <Form.Control
                                    required
                                    type="text"
                                    placeholder="Address1"
                                    value={closingAgentForm.address1}
                                    onChange={handleChangeClosingAgent}
                                    onBlur={handleBlurClosingAgent}
                                    pattern="/^[a-zA-Z0-9#(),'\s]*$/"
                                    maxLength={100}
                                    isInvalid={
                                      !!closingAgentValidationErrors.address1
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {closingAgentValidationErrors.address1}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="address2"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>Address2</Form.Label>

                                  <Form.Control
                                    type="text"
                                    placeholder="Address2"
                                    value={closingAgentForm.address2}
                                    pattern="/^[a-zA-Z0-9#(),'\s]*$/"
                                    onChange={handleChangeClosingAgent}
                                    onBlur={handleBlurClosingAgent}
                                    maxLength={100}
                                    isInvalid={
                                      !!closingAgentValidationErrors.address2
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {closingAgentValidationErrors.address2}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="state"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>State</Form.Label>
                                  <span
                                    className=""
                                    style={{ color: "#d13b3b" }}
                                  >
                                    *
                                  </span>
                                  <Form.Select
                                    required
                                    value={closingAgentForm.state}
                                    onChange={handleChangeClosingAgent}
                                    placeholder="State"
                                    className="form-select-height-state-bid"
                                    onBlur={handleBlurClosingAgent}
                                    isInvalid={
                                      !!closingAgentValidationErrors.state
                                    }
                                  >
                                    <option value="">Select state</option>
                                    {stateList.length > 0 &&
                                      stateList?.map((state) => (
                                        <option key={state} value={state}>
                                          {state}
                                        </option>
                                      ))}
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {closingAgentValidationErrors.state ||
                                      "Please select a state."}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="city"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>City</Form.Label>
                                  <span
                                    className=""
                                    style={{ color: "#d13b3b" }}
                                  >
                                    *
                                  </span>
                                  <Form.Control
                                    required
                                    type="text"
                                    placeholder="City"
                                    value={closingAgentForm.city}
                                    onChange={handleChangeClosingAgent}
                                    onBlur={handleBlurClosingAgent}
                                    isInvalid={
                                      !!closingAgentValidationErrors.city
                                    }
                                  />
                                  {showSuggestionsClosingAgent &&
                                    citySuggestionsClosingAgent.length > 0 && (
                                      <div className="suggestions-container-bid">
                                        {citySuggestionsClosingAgent.map(
                                          (suggestion, index) => (
                                            <div
                                              key={index}
                                              className="suggestion-item"
                                              onClick={() =>
                                                handleSuggestionClickClosingAgent(
                                                  suggestion
                                                )
                                              }
                                            >
                                              {suggestion}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    )}
                                  <Form.Control.Feedback type="invalid">
                                    {closingAgentValidationErrors.city ||
                                      "Please enter a city."}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-md-8 mb-3">
                                <Form.Group
                                  controlId="zip"
                                  className="my-md-0 my-3"
                                >
                                  <Form.Label>Zip</Form.Label>
                                  <span
                                    className=""
                                    style={{ color: "#d13b3b" }}
                                  >
                                    *
                                  </span>
                                  <Form.Control
                                    required
                                    type="text"
                                    placeholder="Zip"
                                    value={closingAgentForm.zip}
                                    onChange={handleChangeClosingAgent}
                                    onBlur={handleBlurClosingAgent}
                                    maxLength={5}
                                    isInvalid={
                                      !!closingAgentValidationErrors.zip
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {closingAgentValidationErrors.zip ||
                                      "Please enter a valid 5-digit zip code."}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                            </form>
                          </div>
                        </div>
                      </>
                    )}
                </Col>
                <Col xs={12} md={6}>
                  {/* Title Insurance Provider Form */}
                  {isTitleInsuranceProviderRequired &&
                    selectedClosingOption === "BUYER_PAYS" && (
                      <div className="mb-4">
                        <h4 className="pt40">Title Provider </h4>
                        <div className="row pt30">
                          <form
                            ref={titleFormRef}
                            noValidate
                            validated={titleInsuranceValidated}
                            onSubmit={handleSubmit}
                          >
                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="name"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>First Name</Form.Label>
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>
                                <Form.Control
                                  required
                                  type="text"
                                  placeholder="First Name"
                                  value={titleInsuranceForm.name}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  maxLength={50}
                                  isInvalid={!!validationErrors.name}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {validationErrors.name ||
                                    "This field is required"}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="email"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>Email</Form.Label>
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>
                                <Form.Control
                                  required
                                  type="email"
                                  placeholder="Email"
                                  value={titleInsuranceForm.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!validationErrors.email}
                                />
                                <Form.Control.Feedback type="invalid">
                                  Please enter a valid email address.
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="company"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>Company</Form.Label>
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>

                                <Form.Control
                                  required
                                  type="text"
                                  placeholder="Company"
                                  value={titleInsuranceForm.company}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  maxLength={50}
                                  isInvalid={!!validationErrors.company}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {validationErrors.company ||
                                    "This field is required"}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="phone"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>Phone Number</Form.Label>
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>

                                <Form.Control
                                  required
                                  type="tel"
                                  placeholder="Phone"
                                  value={titleInsuranceForm.phone}
                                  maxLength={10}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!validationErrors.phone}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {validationErrors.phone ||
                                    "This field is required"}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="address1"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>Address1</Form.Label>
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>

                                <Form.Control
                                  required
                                  type="text"
                                  placeholder="Address1"
                                  value={titleInsuranceForm.address1}
                                  pattern="/^[a-zA-Z0-9#(),'\s]*$/"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  maxLength={50}
                                  isInvalid={!!validationErrors.address1}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {validationErrors.address1 ||
                                    "This field is required"}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="address2"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>Address2</Form.Label>

                                <Form.Control
                                  type="text"
                                  placeholder="Address2"
                                  value={titleInsuranceForm.address2}
                                  pattern="/^[a-zA-Z0-9#(),'\s]*$/"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  maxLength={50}
                                  isInvalid={!!validationErrors.address2}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {validationErrors.address2}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="state"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>State</Form.Label>
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>
                                <Form.Select
                                  required
                                  value={titleInsuranceForm.state}
                                  onChange={handleChange}
                                  placeholder="State"
                                  className="form-select-height-state-bid"
                                  onBlur={handleBlur}
                                  isInvalid={!!validationErrors.state}
                                >
                                  <option value="">Select state</option>
                                  {stateList.length > 0 &&
                                    stateList?.map((state) => (
                                      <option key={state} value={state}>
                                        {state}
                                      </option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                  {validationErrors.state ||
                                    "Please select a state."}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>

                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="city"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>City</Form.Label>
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>
                                <Form.Control
                                  required
                                  type="text"
                                  placeholder="City"
                                  value={titleInsuranceForm.city}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={!!validationErrors.city}
                                />
                                {showSuggestions &&
                                  citySuggestions.length > 0 && (
                                    <div className="suggestions-container-bid">
                                      {citySuggestions.map(
                                        (suggestion, index) => (
                                          <div
                                            key={index}
                                            className="suggestion-item"
                                            onClick={() =>
                                              handleSuggestionClick(suggestion)
                                            }
                                          >
                                            {suggestion}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}
                                <Form.Control.Feedback type="invalid">
                                  {validationErrors.city ||
                                    "Please enter a city."}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                            <div className="col-md-8 mb-3">
                              <Form.Group
                                controlId="zip"
                                className="my-md-0 my-3"
                              >
                                <Form.Label>Zip</Form.Label>
                                <span className="" style={{ color: "#d13b3b" }}>
                                  *
                                </span>
                                <Form.Control
                                  required
                                  type="text"
                                  placeholder="Zip"
                                  value={titleInsuranceForm.zip}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  maxLength={5}
                                  isInvalid={!!validationErrors.zip}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {validationErrors.zip ||
                                    "Please enter a valid 5-digit zip code."}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                </Col>
              </Row>
              <button
                type="submit"
                className="continueCTA"
                onClick={handleSubmit}
              >
                Continue
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EditClosingAgentAndTitleInsuranceProvider;
